import { render, staticRenderFns } from "./jobDetail.vue?vue&type=template&id=635db1d8"
import script from "./jobDetail.vue?vue&type=script&lang=js"
export * from "./jobDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports